<template>

  <div v-if="!overview" class="p-fluid report-field">
    <div v-if="guide.label" class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
    <div v-for="(children) in guide.childrens" :key="children.c_key" class="p-grid p-nogutter p-pt-2 p-pb-1" style="line-height: .8rem;">
      
      <!-- <div class="p-col-2 p-nogutter p-d-flex p-ai-center p-jc-center p-text-center" style="max-width: 150px">{{ $t('report.'+section+'.'+children.c_key+'_pre') }}</div>
      <div class="p-col-2 p-nogutter p-d-flex p-ai-center p-jc-center p-text-center" v-html="$t('report.'+section+'.'+children.c_key+'_pre_val')" style="max-width: 150px"/>
      <div class="p-col-1 p-nogutter p-d-flex p-ai-center p-jc-center" ><b>&#8594;</b></div>
      <div class="p-col-2 p-nogutter p-d-flex p-ai-center p-jc-center p-text-center" style="max-width: 150px">{{ $t('report.'+section+'.'+children.c_key+'_post') }}</div>
      <div class="p-col-4 p-nogutter p-d-flex p-ai-center p-jc-center p-text-center" v-html="$t('report.'+section+'.'+children.c_key+'_post_val')" style="max-width: 150px"/>
      <div class="p-col-1 p-nogutter p-d-flex p-ai-center p-jc-end" >
        <Checkbox v-if="children.c_type==='check'"
            v-model="values[children.c_key]" :binary="true"
            :disabled="guide.disabled"
            @input="dataChanged(children, $event)" 
            :class="{'p-invalid':children.invalid}"/>
      </div> -->

      <!-- <div style="display: inline-block; width: calc(100% - 80px);">
        {{ $t('report.'+section+'.'+children.c_key+'_pre') }}
        &nbsp; <b style="font-size: 1.2rem;">&#8594;</b> &nbsp;
        {{ $t('report.'+section+'.'+children.c_key+'_post') }}
      </div> -->
      
      <div class="p-col p-ai-center">
        <svg width="100%" height="100%" viewBox="0 0 500 18" preserveAspectRatio="xMinYMid meet"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <text x="0" y="16" font-size="18" fill="black">
            {{ $t('report.'+section+'.'+children.c_key+'_pre') }}
            &nbsp; &#8594; &nbsp;
            {{ $t('report.'+section+'.'+children.c_key+'_post') }}
          </text>
        </svg>
      </div>

      <div class="p-col-fixed p-ai-center p-jc-end p-text-right" style="width: 30px">
        <!-- <InputText v-if="children.c_type==='text'" type="text" 
            v-model="values[children.c_key]" 
            @input="dataChanged(children, $event.target.value)"  
            :disabled="guide.disabled"
            :class="{'p-invalid':children.invalid}"
            style="width: 70px;"/> -->
            <Checkbox v-if="children.c_type==='check'"
              v-model="values[children.c_key]" :binary="true"
              :disabled="guide.disabled"
              @input="dataChanged(children, $event)" 
              :class="{'p-invalid':children.invalid}" :aria-label="$t('report.'+section+'.'+children.c_key+'_pre') + ' -> ' + $t('report.'+section+'.'+children.c_key+'_post')"/>
      </div>
      
    </div>
  </div>

  <div v-else class="p-fluid report-field">
    <div v-if="guide.label" class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
    <div v-for="(children) in guide.childrens" :key="children.c_key" style="margin-bottom: .3rem;">
      
      <span v-if="children.c_type==='text'" >
        {{ data[children.c_key] ?? '-' }}
      </span>

      <span v-if="children.c_type==='check'" >
        <Checkbox v-if="children.c_type==='check'"
          v-model="values[children.c_key]" :binary="true"
          :disabled="true"  :aria-label="$t('report.'+section+'.'+children.c_key+'_pre') + ' -> ' + $t('report.'+section+'.'+children.c_key+'_post')"/>
      </span>
      
    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      domains: Object,
      overview: Boolean
    },
  data() {
    return {
      values: {}
    }
  },
  computed: {
  },
  created() {
    for(let children of this.guide.childrens) {
      if(children.c_type === 'text') {
        this.values[children.c_key] = this.data[children.c_key];
      } else if(children.c_type === 'check') {
        this.values[children.c_key] = this.data[children.c_key];
      }
    }
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(children, newValue) {
      if(children.c_type==='text') {
        this.$emit("update:data", { key: children.c_key, value: newValue });
      } else if(children.c_type==='check') {
        this.$emit("update:data", { key: children.c_key, value: newValue });
      }
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        for(let key in this.values) {
          this.values[key] = null;
        }
      }
    }
    
  }
}
</script>

<style scoped>

</style>